import React, { useMemo, useState } from 'react';
import { Tooltip } from 'reactstrap';
import { getCatalogItem, isNavIdDisabled } from '../Utils/sidebarCatalog';
import { getNavLabelForRole, getNavPathForRole } from '../Utils/sidebarLayoutUtils';
import { SidebarIcon } from '../Utils/sidebarIcons';
import { getSidebarActiveNavId } from '../Utils/sidebarActiveNav';

function flattenLayoutNavIds(layout) {
  const links = [];
  const walk = (nodes) => {
    for (const node of nodes || []) {
      if (!node) continue;
      if (node.kind === 'link' && node.navId && !isNavIdDisabled(node.navId)) {
        links.push(node.navId);
      } else if (node.kind === 'group') {
        walk(node.children);
      }
    }
  };
  walk(layout);
  const withoutLogout = links.filter((id) => id !== 'item35');
  if (links.includes('item35')) {
    withoutLogout.push('item35');
  }
  return withoutLogout;
}

const CollapsedSidebarNavRenderer = ({
  layout,
  roleId,
  location,
  navigate,
  onLogout,
}) => {
  const navIds = useMemo(() => flattenLayoutNavIds(layout), [layout]);
  const activeNavId = useMemo(
    () => getSidebarActiveNavId(location.pathname, location.search),
    [location.pathname, location.search]
  );
  const [openTipId, setOpenTipId] = useState(null);

  const toggleTip = (navId) => {
    setOpenTipId((prev) => (prev === navId ? null : navId));
  };

  const handleNav = (navId) => {
    const meta = getCatalogItem(navId);
    const route = getNavPathForRole(roleId, navId, meta);
    if (route === '__logout__') {
      onLogout?.();
      return;
    }
    navigate(route);
  };

  if (!navIds.length) return null;

  return (
    <ul style={{ paddingLeft: 0 }}>
      {navIds.map((navId) => {
        const meta = getCatalogItem(navId);
        const label = getNavLabelForRole(roleId, navId, meta);
        const icon = meta?.icon || 'BiDesktop';
        const active = activeNavId === navId;
        const tipClass = `tip-collapsed-${navId}`;

        return (
          <React.Fragment key={navId}>
            <li id="li-style" className={tipClass}>
              <button
                type="button"
                id={active ? 'close-active-li-button' : 'close-li-button'}
                className="border-0 bg-transparent w-100 text-start"
                onClick={() => handleNav(navId)}
              >
                <p id="icon-name">
                  <SidebarIcon name={icon} iconClassName="sidebar-nav-icon sidebar-nav-icon--collapsed" />
                </p>
              </button>
            </li>
            <Tooltip
              target={`.${tipClass}`}
              placement="right"
              id="tooltip-style"
              toggle={() => toggleTip(navId)}
              isOpen={openTipId === navId}
            >
              {label}
            </Tooltip>
          </React.Fragment>
        );
      })}
    </ul>
  );
};

export default CollapsedSidebarNavRenderer;
